<template>
  <div class="home-section">
    <div class="class-banner-wrap">
      <img src="@/image/workCenter/banner.png" alt width="100%" />
    </div>
    <div class="class-container_menu">
      <div class="class_menu-section">
        <el-menu class="el-menu-vertical-demo" active-text-color="#fa9241">
          <el-menu-item index="1" @click="getChoicenessData()">
            <span>精选作品</span>
          </el-menu-item>
          <el-submenu index="2">
            <template slot="title">
              <span>三/四年级</span>
            </template>
            <el-menu-item
              v-for="(item, index) in season"
              :key="index"
              :index="2 + '-' + (index + 1)"
              @click="getProductionDataShow([3, 4], index + 1)"
              >{{ item }}</el-menu-item
            >
          </el-submenu>
          <el-submenu index="3">
            <template slot="title">
              <span>五/六年级</span>
            </template>
            <el-menu-item
              v-for="(item, index) in season"
              :key="index"
              :index="3 + '-' + (index + 1)"
              @click="getProductionDataShow([5, 6], index + 1)"
              >{{ item }}</el-menu-item
            >
          </el-submenu>
          <el-submenu index="4">
            <template slot="title">
              <span>七/八年级</span>
            </template>
            <el-menu-item
              v-for="(item, index) in season"
              :key="index"
              :index="4 + '-' + (index + 1)"
              @click="getProductionDataShow([7, 8], index + 1)"
              >{{ item }}</el-menu-item
            >
          </el-submenu>
        </el-menu>
      </div>
      <div class="main-show_container">
        <div class="main-show_section">
          <div class="main-show_search">
            <el-select
              v-model="filterData.school"
              size="medium"
              filterable
              placeholder="请选择学校"
            >
              <el-option
                v-for="item in schoolData"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <el-input
              size="medium"
              placeholder="请输入学生姓名"
              v-model="filterData.student_name"
              clearable
              class="name-input"
            >
            </el-input>
            <el-input
              size="medium"
              placeholder="请输入指导老师姓名"
              v-model="filterData.teacher_name"
              clearable
              class="name-input"
            >
            </el-input>
          </div>
          <el-button type="primary" plain size="medium" @click="search"
            >查询</el-button
          >
        </div>
        <div
          class="temporary_show-container"
          v-if="studentWorkList.length === 0"
        >
          暂无数据
        </div>
        <div class="main-show_section_list">
          <router-link
            class="main-show_item"
            v-for="item in studentWorkList"
            :key="item.id"
            :to="{ name: 'works_center_data', params: { id: item.id } }"
          >
            <img
              :src="(item.file || {}).file_src"
              class="main-show_item_image"
              v-if="item.file"
            />
            <p class="main-show_item_noimage" v-else>
              暂未上传封面
            </p>
            <div class="main-show_item_text">
              <p class="title">{{ item.poetry_name }}</p>
              <div class="desc">
                <p class="user_name">作者: {{ item.author }}</p>
                <p class="teacher_name">指导老师: {{ item.teacher_name }}</p>
              </div>
            </div>
          </router-link>
        </div>
        <div class="paging-container">
          <div class="paging-section">
            <el-pagination
              background
              layout="prev, pager, next"
              :page-size="pageSize"
              :current-page="currentPage"
              :total="total"
              @current-change="editCurrentPage"
              :hide-on-single-page="true"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import constService from "@/global/service/const";
import workService from "@/global/service/work";

export default {
  data() {
    return {
      schoolData: [],
      studentWorkList: [],
      season: ["春季", "夏季", "秋季", "冬季"],
      name: "",
      site: [],
      school_id: "",
      seasonIndex: null,
      grade: null,
      pageSize: 10,
      total: null,
      currentPage: 1,
      districtOption: [],
      filterData: {
        school: "",
        teacher_name: "",
        student_name: ""
      },
      paginationType: "choice"
    };
  },
  created() {
    Promise.all([constService.school()]).then(res => {
      this.schoolData = res[0];
    });
    this.getChoiceData();
  },
  methods: {
    getChoicenessData() {
      this.paginationType = "choice";
      this.currentPage = 1;
      for (let key in this.filterData) {
        this.filterData[key] = "";
      }
      this.grade_id = null;
      this.season_id = null;
      this.getChoiceData();
    },
    getChoiceData() {
      const params = {
        is_choice: 1,
        page: this.currentPage,
        page_size: this.pageSize
      };
      workService.studentWork(params).then(res => {
        this.studentWorkList = res.list;
        this.currentPage = res.pagination.current_page;
        this.total = res.pagination.total;
      });
    },
    editCurrentPage(index) {
      this.currentPage = index;
      this.getData();
    },
    getData() {
      if (this.paginationType === "choice") {
        this.getChoiceData();
      } else if (this.paginationType === "search") {
        this.getSearchData();
      } else if (this.paginationType === "grade") {
        this.getGradeData();
      }
    },
    search() {
      this.paginationType = "search";
      this.grade_id = null;
      this.season_id = null;
      this.currentPage = 1;
      this.getSearchData();
    },
    getSearchData() {
      const params = {
        school_id: this.filterData.school,
        author: this.filterData.student_name,
        teacher_name: this.filterData.teacher_name,
        page: this.currentPage,
        page_size: this.pageSize
      };
      workService.studentWork(params).then(res => {
        this.studentWorkList = res.list;
        this.total = res.pagination.total;
        this.currentPage = res.pagination.current_page;
      });
    },
    getProductionDataShow(grade, season) {
      this.paginationType = "grade";
      this.grade = grade;
      this.seasonIndex = season;
      for (let key in this.filterData) {
        this.filterData[key] = "";
      }
      this.currentPage = 1;
      this.getGradeData();
    },
    getGradeData() {
      const params = {
        grade_id: this.grade,
        season_id: this.seasonIndex,
        page: this.currentPage,
        page_size: this.pageSize
      };
      workService.studentWork(params).then(res => {
        this.studentWorkList = res.list;
        this.total = res.pagination.total;
        this.currentPage = res.pagination.current_page;
      });
    }
  }
};
</script>
<style lang="less" scoped>
.class-banner-wrap {
  min-width: 960px;
}
.class-container_menu {
  display: flex;
  width: 70%;
  min-width: 960px;
  padding-top: 20px;
  margin: 0 auto;
  overflow: hidden;
  .class_menu-section {
    flex: none;
    width: 227px;
    /deep/ .el-submenu .el-menu-item.is-active {
      border-left: 2px solid #fa9241;
    }
  }
  .main-show_container {
    display: flex;
    padding-left: 30px;
    flex-direction: column;
    flex: 1;
    .main-show_section {
      display: flex;
      justify-content: space-between;
      margin-bottom: 21px;
      align-items: flex-start;
      .main-show_search {
        flex: 1;
        display: flex;
        div {
          margin-right: 12px;
          width: 30%;
        }
      }
    }
    .temporary_show-container {
      margin-left: 12px;
    }
    .main-show_section_list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      flex: 1;
      font-size: 0;
      .main-show_item {
        width: 49%;
        margin-bottom: 30px;
        text-decoration: none;
        color: #333;
        .main-show_item_image {
          width: 100%;
          height: calc(100vh / 2.6);
          object-fit: cover;
        }
        .main-show_item_noimage {
          width: 100%;
          height: calc(100vh / 2.6);
          border: 1px solid #ffc84e;
          font-size: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #999;
        }
        .main-show_item_text {
          background-color: #ffc84e;
          font-size: 12px;
          padding: 10px;
          text-align: left;
          .title {
            display: block;
            font-weight: 700;
            line-height: 30px;
            font-size: 16px;
          }
          .desc {
            p {
              display: inline-block;
              width: 50%;
            }
          }
        }
      }
    }
    .paging-container {
      .paging-section {
        text-align: center;
      }
    }
  }
}
.name-input {
  /deep/.el-input__inner {
    padding-right: 0;
  }
}
</style>
